/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-11 09:51:03
 * @LastEditors: yd
 * @LastEditTime: 2020-09-23 18:18:14
 */
//流水号配置
import http from '../httpConfig'

const table = "mrbase_sys_swift_config"


// 获取所有流水号配置
export const getserialNumberList = (params = {}) => {
    params['~table~'] = 'mrbase_sys_swift_config'
    return new Promise((resolve, reject) => {
        http.post('/api/common/list-serialnumber/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 生成流水号
export const createSerialNumber = (params = {}) => {
    return new Promise((resolve, reject) => {
        http.post('/api/common/create-serialnumber/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}


// 获取流水号详情配置
export const detailSerialNumber = (params = {}) => {
    params['~table~'] = 'mrbase_sys_swift_config'
    return new Promise((resolve, reject) => {
        http.post('/api/common/find-serialnumber/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 新增流水号配置接口
export const addSerialNumber = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/common/add-serialnumber/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 修改流水号接口
export const updateSerialNumber = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/common/update-serialnumber/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 删除流水号配置
export const deleteSerialNumber = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/common/delete-serialnumber/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}